/**
 * Pure helpers for conversation label assignments (no Supabase imports so
 * they're unit-testable). The API layer (src/api/conversationLabels.ts) uses
 * the diff to turn "these should be the conversation's labels" into minimal
 * insert/delete sets.
 */

export interface LabelAssignmentDiff {
  toAdd: string[]
  toRemove: string[]
}

/** Minimal changes to get from `current` label ids to `next` (order-insensitive, deduped). */
export function diffLabelAssignments(current: string[], next: string[]): LabelAssignmentDiff {
  const currentSet = new Set(current)
  const nextSet = new Set(next)
  const toAdd: string[] = []
  const toRemove: string[] = []
  nextSet.forEach((id) => {
    if (!currentSet.has(id)) toAdd.push(id)
  })
  currentSet.forEach((id) => {
    if (!nextSet.has(id)) toRemove.push(id)
  })
  return { toAdd, toRemove }
}

/** conversation_id -> label ids, from raw assignment rows. */
export function groupAssignmentsByConversation(
  rows: Array<{ conversation_id: string; label_id: string }>
): Record<string, string[]> {
  const byConvo: Record<string, string[]> = {}
  for (const row of rows) {
    const list = byConvo[row.conversation_id]
    if (list) {
      if (!list.includes(row.label_id)) list.push(row.label_id)
    } else {
      byConvo[row.conversation_id] = [row.label_id]
    }
  }
  return byConvo
}
